<section id="pageNotFound">
    <div class="row align-items-center">
        <div class="col-12 col-md-7">
            <div class="text-container">
                <h1 class="m-0">{{ 'PAGE_NOT_FOUND_TITLE' | translate }}</h1>
                <span [innerHTML]="'PAGE_NOT_FOUND' | translate | safeHTML"></span>
                <div class="d-flex">
                    <button class="btn btn-secondary me-4" [uiSref]="'portal'">
                        {{ 'STATIC_GO_BACK_TO_PORTAL' | translate }}
                    </button>
                    <button class="btn btn-success" [uiSref]="'contact'">
                        {{ 'SHD_GO_TO_CONTACT' | translate }}
                    </button>
                </div>
            </div>
        </div>
        <div class="col-md-5 d-md-flex d-none justify-content-end">
            <img class="img-fluid" [attr.alt]="'ERROR_IMAGE' | translate" src="assets/img/gerd_error.png" />
        </div>
    </div>
</section>
